import React from 'react';

import { getObjectiveLocale } from 'utils/HelperUtils';

import WeightSettingsCard from './fragments/WeightSettingsCard';
import WeightSettingsInputNumber from './fragments/WeightSettingsInputNumber';

const WeightSettingsMaximumSum = ({ configData, changeObjectiveConfig }) => {
  const {
    objectivesConfig: {
      maxSumOfObjectivesWeightPercentageOn,
      maxSumOfObjectivesWeightPercentage
    }
  } = configData;

  const changeCallback = async ({ value, keys }) => {
    const isSuccess = await changeObjectiveConfig({ [keys]: value });
    return isSuccess;
  };

  return (
    <WeightSettingsCard
      title={'Maximum for the sum of all objective weights'}
      subTitle={
        "Show the expected maximum value for total weight of user's objectives"
      }
      isOpen={maxSumOfObjectivesWeightPercentageOn}
      toggleCallback={({ value }) =>
        changeCallback({ value, keys: 'maxSumOfObjectivesWeightPercentageOn' })
      }
      toggleCy={'toggle-max-sum'}
    >
      <div className="flex flex-col">
        <p className="typography-h100 text-n-800 mb-[8px]">
          {getObjectiveLocale('Maximum total weight (%)')}
        </p>
        <div className="flex flex-row items-center">
          <WeightSettingsInputNumber
            defaultValue={maxSumOfObjectivesWeightPercentage}
            onChangeCallback={(value) =>
              changeCallback({
                value,
                keys: 'maxSumOfObjectivesWeightPercentage'
              })
            }
            dataCy="max-sum-weight-input"
          />
        </div>
      </div>
    </WeightSettingsCard>
  );
};

export default WeightSettingsMaximumSum;
